import '../pagination-element';
import {until} from 'lit-html/directives/until';

export default (ctx, html) => html`
  <pagination-element num-pages="${ctx.numPages}" current-page="${ctx.currentPage}" disable-pages @page-change="${ctx.pageChange}" ?disabled="${ctx.disabled}">
    <span slot="prev-label">${until(ctx.__('<tt-NRvCNZ86>', 'Prev'))}</span>
    <span slot="next-label">${until(ctx.__('<tt-ti0NQ4Jl>', 'Next'))}</span>
  </pagination-element>
`;
